import axios from "axios";

import { apiKey, bctBaseUrl, msBaseUrl, pbBaseUrl } from "../landPageConfig";

//* Miami Springs extents
export const getMsExtents = async (): Promise<{ extentsToReturn: MapRange; msAgencyId: string }> => {
  try {
    const { data } = await axios.get(`${msBaseUrl}/api/where/agencies-with-coverage.json?key=${apiKey}`);
    // console.log("data:", data);
    const extents = data?.data?.list?.[0];
    const msAgencyId = data?.data?.list?.[0]?.agencyId;

    const extentsToReturn: MapRange = Object.assign(
      {},
      { lat: extents?.lat },
      { lon: extents?.lon },
      { latSpan: extents?.latSpan },
      { lonSpan: extents?.lonSpan }
    );
    // console.log("extentsToReturn:", extentsToReturn);
    return { extentsToReturn, msAgencyId };
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};

//* Pompano Beach extents
export const getPbExtents = async (): Promise<{ extentsToReturn: MapRange; pbAgencyId: string }> => {
  try {
    const { data } = await axios.get(`${pbBaseUrl}/api/where/agencies-with-coverage.json?key=${apiKey}`);
    // console.log("data:", data);
    const extents = data?.data?.list?.[0];
    const pbAgencyId = data?.data?.list?.[0]?.agencyId;

    const extentsToReturn: MapRange = Object.assign(
      {},
      { lat: extents?.lat },
      { lon: extents?.lon },
      { latSpan: extents?.latSpan },
      { lonSpan: extents?.lonSpan }
    );
    // console.log("extentsToReturn:", extentsToReturn);
    return { extentsToReturn, pbAgencyId };
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};

//* Broward County Transit extents
export const getBCTExtents = async (): Promise<{ extentsToReturn: MapRange; pbAgencyId: string }> => {
  try {
    const { data } = await axios.get(`${bctBaseUrl}/api/where/agencies-with-coverage.json?key=${apiKey}`);
    // console.log("data:", data);
    const extents = data?.data?.list?.[0];
    const pbAgencyId = data?.data?.list?.[0]?.agencyId;

    const extentsToReturn: MapRange = Object.assign(
      {},
      { lat: extents?.lat },
      { lon: extents?.lon },
      { latSpan: extents?.latSpan },
      { lonSpan: extents?.lonSpan }
    );
    // console.log("extentsToReturn:", extentsToReturn);
    return { extentsToReturn, pbAgencyId };
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};

export const getGlobalCoordinates = (array: MapRange[]): MapRange => {
  const finalArray: MapRange[] = array?.filter((elem: MapRange) => elem !== undefined);

  let minLat: number = Infinity,
    maxLat: number = -Infinity;
  let minLon: number = Infinity,
    maxLon: number = -Infinity;

  for (const obj of finalArray) {
    const objMinLat = obj?.lat - obj?.latSpan / 2;
    const objMaxLat = obj?.lat + obj?.latSpan / 2;
    const objMinLon = obj?.lon - obj?.lonSpan / 2;
    const objMaxLon = obj?.lon + obj?.lonSpan / 2;

    if (objMinLat < minLat) minLat = objMinLat;
    if (objMaxLat > maxLat) maxLat = objMaxLat;
    if (objMinLon < minLon) minLon = objMinLon;
    if (objMaxLon > maxLon) maxLon = objMaxLon;
  }

  const globalLat = (minLat + maxLat) / 2;
  const globalLon = (minLon + maxLon) / 2;
  const globalLatSpan = maxLat - minLat;
  const globalLonSpan = maxLon - minLon;

  const globalLatLon: MapRange = {
    lat: globalLat,
    lon: globalLon,
    latSpan: globalLatSpan,
    lonSpan: globalLonSpan,
  };

  return globalLatLon;
};

//* Get Miami Springs buses
export const getMsBuses = async (agencyId: string, agencyName: string): Promise<BusInfo[]> => {
  try {
    const { data } = await axios.get(`${msBaseUrl}/api/where/vehicles-for-agency/${agencyId}.json?key=${apiKey}`);
    const activeMsBuses = data?.data?.list;
    // console.log("activeMsBuses:", activeMsBuses);
    const mappedActiveMsBuses = activeMsBuses?.map((bus: BusInfo) => {
      return { ...bus, agencyId: agencyId, agencyName: agencyName };
    }) as BusInfo[];

    return mappedActiveMsBuses;
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};

//* Get Pompano Beach buses
export const getPbBuses = async (agencyId: string, agencyName: string): Promise<BusInfo[]> => {
  try {
    const { data } = await axios.get(`${pbBaseUrl}/api/where/vehicles-for-agency/${agencyId}.json?key=${apiKey}`);
    const activeMsBuses = data?.data?.list;
    // console.log("activeMsBuses:", activeMsBuses);
    const mappedActiveMsBuses = activeMsBuses?.map((bus: BusInfo) => {
      return { ...bus, agencyId: agencyId, agencyName: agencyName };
    }) as BusInfo[];

    return mappedActiveMsBuses;
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};

//* Get Broward County Transit buses
export const getBctBuses = async (agencyId: string, agencyName: string): Promise<BusInfo[]> => {
  try {
    const { data } = await axios.get(`${bctBaseUrl}/api/where/vehicles-for-agency/${agencyId}.json?key=${apiKey}`);
    const activeMsBuses = data?.data?.list;
    // console.log("activeMsBuses:", activeMsBuses);
    const mappedActiveMsBuses = activeMsBuses?.map((bus: BusInfo) => {
      return { ...bus, agencyId: agencyId, agencyName: agencyName };
    }) as BusInfo[];

    return mappedActiveMsBuses;
  } catch (error) {
    console.log("error:", error);
    return null as any;
  }
};
